import React, {Component} from 'react';
import {Link} from 'gatsby';
import {goToAnchor} from 'react-scrollable-anchor';
import styled from 'styled-components';
import {brk} from "../styles/constants";


const StyledLink = styled.div`
  width: auto;
  max-width: 325px;
  background: none;
  border: 2px solid black;
  padding: 10px 30px 10px 30px;
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  display: block;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  -webkit-transition:0.5s;
  position: relative;
  color: black;
  cursor: pointer;
  text-align: center;

  &:hover{
    border: 2px solid whitesmoke;
    color: black;
  }

  &:before{
    width: 100%;
    /*height:100%;*/
    z-index: 3;
    content:'';
    position: absolute;
    bottom:0;
    left:0;
    box-sizing: border-box;
    -webkit-transform: scale(0);
    transition: 0.9s;
    border-bottom: 2px solid #FD9D87;
    -webkit-transform-origin: 0% 100%;
  }

  &:hover::after{
    -webkit-transform: scale(1);
  }
  &:hover::before{
    -webkit-transform: scale(1);
  }
`;

class ButtonUnderline extends Component {

    render() {
        const {linkSlug , linkLabel} = this.props;

        return (
            <StyledLink>
                <Link className={'btn_underline'} to={linkSlug} >
                    {linkLabel}
                </Link>
            </StyledLink>
        );
    }
}

export default ButtonUnderline;
